// extracted by mini-css-extract-plugin
export default {"Paginator":"Paginator_Paginator__dx17q","paginateButton":"Paginator_paginateButton__AnW3N"};